import { useCurrentNetworkPermalink, useLegacyHost } from '../session';

type UseLegacyUrl = (path: string) => string;
export const useLegacyUrl: UseLegacyUrl = (path) => {
  const legacyHost = useLegacyHost();
  const currentNetworkPermalink = useCurrentNetworkPermalink();

  return `${legacyHost}/${currentNetworkPermalink}${path}`;
};
